import type { AppearanceVariant } from '../types';

import { DossierPreview } from '../previews/dossier';

export const dossierVariant: AppearanceVariant = {
  id: 'dossier',
  nameKey: 'appearance.dossier',
  descriptionKey: 'appearance.dossierDescription',
  className: 'erp-dossier',
  composition: 'folio',
  groupedNavigation: true,
  documentEntry: 'guided',
  Preview: DossierPreview,
};
